/**
 * ASN courier and transport choices, and how a courier is labelled.
 *
 * Mirrors ``AdvancedShippingNotice.COURIER_CHOICES`` /
 * ``TRANSPORT_METHOD_CHOICES`` on the backend.
 */

/** Courier choices accepted by the ASN API. */
export const COURIER_OPTIONS: { value: string; label: string }[] = [
  { value: 'fedex', label: 'FedEx' },
  { value: 'ups', label: 'UPS' },
  { value: 'dhl', label: 'DHL' },
  { value: 'tnt', label: 'TNT' },
  { value: 'dpd', label: 'DPD' },
  { value: 'own_transport', label: 'Own Transport' },
  { value: 'poeton_transport', label: 'Poeton Transport' },
  { value: 'other', label: 'Other' },
];

/** Transport methods accepted by the ASN API. */
export const TRANSPORT_METHOD_OPTIONS: { value: string; label: string }[] = [
  { value: 'road', label: 'Road' },
  { value: 'rail', label: 'Rail' },
  { value: 'air', label: 'Air' },
  { value: 'sea', label: 'Sea' },
];

/**
 * Display text for an ASN's courier: the typed-in name for an "Other"
 * courier, otherwise the courier code with underscores as spaces.
 *
 * @param courier - The ASN's courier code.
 * @param courierOther - The free-text name used when the courier is 'other'.
 * @returns The courier label, or '-' when there is none.
 */
export function formatCourier(courier?: string, courierOther?: string): string {
  if (courier === 'other' && courierOther) return courierOther;
  return courier ? courier.replace(/_/g, ' ') : '-';
}
